import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "resource-grid" }
const _hoisted_4 = { class: "resource-icon" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { key: 1 }


export default /*@__PURE__*/_defineComponent({
  __name: 'StudentsView',
  setup(__props) {

const resources = [
  {
    title: 'Courses',
    emoji: '💻',
    image: '',
    description: 'Free, self-paced curriculum developed by Space Coast STEM. Coding, computer fundamentals, and more.',
    to: '/students/courses'
  },
  {
    title: 'Mattermost',
    emoji: '💬',
    image: '/assets/img/logos/mattermost.png',
    description: 'Our private, safe messaging platform where students can connect with volunteer mentors for help and collaboration.',
    to: '/students/mattermost'
  }
]

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", null, [
    _cache[3] || (_cache[3] = _createElementVNode("section", { class: "hero" }, [
      _createElementVNode("div", { class: "hero-content" }, [
        _createElementVNode("h2", null, "For Students"),
        _createElementVNode("p", null, "Free curriculum, community, and resources to help you build real-world tech skills")
      ])
    ], -1)),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Student Resources", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", null, "Pick a resource to learn more about what's available to you.", -1)),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(resources, (resource) => {
            return _createVNode(_component_router_link, {
              key: resource.title,
              to: resource.to,
              class: "resource-card"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  (resource.image)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: resource.image,
                        alt: `${resource.title} logo`
                      }, null, 8, _hoisted_5))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(resource.emoji), 1))
                ]),
                _createElementVNode("h3", null, _toDisplayString(resource.title), 1),
                _createElementVNode("p", null, _toDisplayString(resource.description), 1),
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "resource-link" }, "Learn more →", -1))
              ]),
              _: 2
            }, 1032, ["to"])
          }), 64))
        ])
      ])
    ])
  ]))
}
}

})